import {investorApiClient} from '../apiClient';
import {serializeOnboardingCompanyInfoStep} from './serializers';
import {
  OnboardingCompanyInfoStepParams,
  OnboardingDataParams,
  OnboardingDataResponse,
  OnboardingDataUpdateParams
} from './types';
import {OnboardingSteps} from '../../constants/OnboardingSteps';

export const requestOnboardingStatus = async (companyId: number): Promise<void> => {
  await investorApiClient.get<void>(`company/${companyId}/confirmed`);
};

export const requestOnboardingData = async (
  companyID: number,
  step: OnboardingSteps
): Promise<OnboardingDataResponse> => {
  const {data} = await investorApiClient.get<OnboardingDataResponse>(
    `company/${companyID}/onboarding/step/${step}`
  );

  return data;
};

export const requestSaveOnboardingData = async ({
  step,
  companyId,
  values
}: OnboardingDataUpdateParams): Promise<void> => {
  let data: OnboardingDataParams | FormData;

  switch (step) {
    case OnboardingSteps.PERSONAL_INFO:
    case OnboardingSteps.INVESTING_INTEREST:
      data = values;
      break;
    case OnboardingSteps.COMPANY_INFO:
      data = serializeOnboardingCompanyInfoStep(values as OnboardingCompanyInfoStepParams);
      break;
    default:
      throw new Error('Invalid onboarding step: expected numeric 1, 2 or 3');
  }

  await investorApiClient.put<void>(`company/${companyId}/onboarding/step/${step}`, data);
};

export const requestCompleteOnboarding = async (companyId: number): Promise<void> => {
  await investorApiClient.post(`company/${companyId}/onboarding/complete`);
};
